import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {TransactionInfoService} from "../../../services/transaction-info.service";
import {ClaimTypes} from "../../../model/claim-type.model";

@Component({
    selector: 'app-trip-curtailment',
    templateUrl: './trip-curtailment.component.html',
    styleUrls: ['./trip-curtailment.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TripCurtailmentComponent implements OnInit {

    constructor( private transactionInfoService: TransactionInfoService) {
        this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_CRTL]);
    }

  ngOnInit() {
  }

}
